<template>
  <div id="admin-container" class="wrapper">
    <div class="inner-wrap">
      <div class="table-filter" v-if="1==2">
        <input id="admin-search-grapevines" type="text" v-model="grapevinesQuery" v-on:keyup.enter="doGrapevineSearch" placeholder="Search grapevines" />
        <button id="btnDoSearch" v-on:click="doGrapevineSearch()" class="pure-button">Search</button>
        <button id="btnClearSearch" v-on:click="clearSearch()" class="pure-button">Clear</button>
      </div>
      <HotTable :root="root" ref="grapeFlagsTable" :settings="hotSettings" :onAfterChange="afterChangeHandler"></HotTable>
    </div>
  </div>
</template>

<script>
  /* global $ */
  import HotTable from 'vue-handsontable-official'
  import firebase from 'firebase'
  import db from '../firebaseInit'
  import Router from '../../router'

  export default {
    data: function () {
      return {
        root: 'grape-flags-table',
        userLoggedIn: false,
        userIsAdmin: this.$globals.userRole == 'admin',
        flags: [],
        grapevinesQuery: '',
        searchLimit: 200,
        pageLimit: 1500,
        hotSettings: {
          data: this.grapevines,
          rowHeaders: true,
          contextMenu: true,
          stretchH: 'all',
          autoWrapRow: true,
          className: 'htCenter htMiddle',
          columnSorting: true,
          sortIndicator: true,
          observeChanges: false,
          colHeaders: ['Doc ID', 'Flag Type', 'Grape ID', 'Author', 'Title', 'Content', 'Flag Text', 'User ID', 'Created', 'Reviewed', 'Notes'],
          rowHeights: 50,
          colWidths: [180, 120, 150, 150, 150, 300, 300, 130, 200, 140, 200],
          columns: [
            {data: 'docID', readOnly: true},
            {data: 'flag-type', readOnly: true},
            {data: 'grapeID', readOnly: true},
            {data: 'grapeAuthor', readOnly: true},
            {data: 'grapeTitle', readOnly: true},
            {data: 'grapeContent', readOnly: true},
            {data: 'text', readOnly: true},
            {data: 'userID', readOnly: true},
            {data: 'createdTimestamp', readOnly: true},
            {data: 'reviewed', renderer: 'html', readOnly: true},
            {data: 'notes', readOnly: false}
          ]
        }
      }
    },
    name: 'grapevinesAdmin',
    components: {
      HotTable
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          vm.userLoggedIn = true
        } else {
          vm.userLoggedIn = false
        }
      })
      vm.$globals.isAdmin = true
      vm.showLoading()
      vm.getFlags()
      /* Set Change Callback */
      vm.hotSettings.afterChange = vm.afterChangeHandler()
    },
    methods: {
      showLoading () {
        $('body').addClass('pace-running')
        $('.pace').addClass('pace-active')
      },
      hideLoading () {
        $('body').removeClass('pace-running')
        $('.pace').removeClass('pace-active')
      },
      afterChangeHandler: function (changes, source) {
        if (arguments[1] !== 'loadData') {
          if (!changes) {
            return
          }
          for (var i = 0, iLen = changes.length; i < iLen; i += 1) {
            if (changes[i][2] !== changes[i][3]) {
              console.log('trying to change')
              let logicalIndex = this.$refs.grapeFlagsTable.table.runHooks('modifyRow', changes[i][0])
              let changedDocID = this.$refs.grapeFlagsTable.table.getDataAtCell(changes[i][0], 0)
              let newData = this.$refs.grapeFlagsTable.table.getSourceDataAtRow(logicalIndex)
              if (changedDocID) {
                this.processChange(changedDocID, newData.notes)
              }
            }
          }
        }
      },
      getFlags: function () {
        let vm = this
        var flagsRef = db.collection('grapeFlags').orderBy('createdTimestamp', 'desc').limit(vm.pageLimit)
        flagsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var flagData = doc.data()
            flagData.docID = doc.id
            if (flagData.reviewed) {
              flagData.reviewed = 'Reviewed'
            } else {
              flagData.reviewed = '<a href="#" data-id="' + doc.id + '" class="flag-mark-reviewed">Mark as reviewed</a>'
            }
            this.flags.push(flagData) 
          })
          /* Load Data */
          vm.$refs.grapeFlagsTable.table.loadData(vm.flags)
          setTimeout(function () {
            vm.hideLoading()
          }, 1000)
        })
      },
      markReviewed (docID) {
        console.log('trying to update flag')
        var flagRef = db.collection('grapeFlags').doc(docID)
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        flagRef.update({
          reviewed: true,
          updatedTimestamp: timestamp
        })
        .then(function (docRef) {
          console.log('Document ' + docID + ' successfully updated!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      processChange (docID, notes) {
        console.log('trying to update grape')
        var flagRef = db.collection('grapeFlags').doc(docID)
        const timestamp = firebase.firestore.FieldValue.serverTimestamp()
        flagRef.update({
          notes: notes,
          updatedTimestamp: timestamp
        })
        .then(function (docRef) {
          console.log('Document ' + docID + ' successfully updated!')
        })
        .catch(function (error) {
          // The document probably doesn't exist.
          console.error('Error updating document: ', error)
        })
      },
      loadGrapevineGrapes (docID, grapevineName) {
        Router.push({name: 'admin-grapevine', params: {id: docID, name: encodeURIComponent(grapevineName)}})
      }
    },
    mounted () {
      let $vue = this
      $(document).on('click', '.flag-mark-reviewed', function () {
        $vue.markReviewed($(this).data('id'))
        $(this).replaceWith('Reviewed')
        return false
      })
    }
  };
</script>

<style>
  .table-filter {
    padding: 10px 0;
  }
  .table-filter input {
    height: 40px;
    width: 300px;
    padding: 4px 10px;
    box-sizing: border-box;
  }
  .table-filter .pure-button {
    vertical-align: top;
  }
  #grape-flags-table {
    width: 100%;
    height: 100vh;
    height: calc(100vh - 60px);
    margin-top: 4px;
    overflow: hidden;
  }
  #grape-flags-table th {
    vertical-align: middle;
  }
  #grape-flags-table td {
    max-width: 320px;
    min-width: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    padding: 0 10px;
  }
  #grape-flags-table thead th .relative {
    padding: 4px 8px;
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/grapeFlags.vue